export default "__VITE_ASSET__CknEs6yz__"